import { ref, computed } from "vue";
import { defineStore } from "pinia";
import en from '@/languages/en.json';

export const useAppStore = defineStore("appStore", () => {
  /* Public variables */
  const brandIcon = computed(() => { return 'mdi-calculator-variant'; });
  const img = ref<any>({ h: 628, w: 1256 });
  const isDark = ref<boolean>(true);
  const isMenu = ref<boolean>(false);
  const isMobile = ref<any>();
  const siteName = computed(() => { return 'NEAT'; });
  const tagLine = computed(() => { return 'Rigging Calculator'; });
  const userLang: string = navigator.language.substring(0, 2);

  const txt = computed(() => { 
    switch (userLang) {
      //case 'es': return { ...es };
      default: return { ...en };
    }
  });
  
  const langs = ref<Array<any>>([
    { id: 'en', name: txt.value.english },
    //{ id: 'es', name: txt.value.spanish }
  ]);

  return {
    brandIcon, img, isDark, isMenu, isMobile, langs, siteName, tagLine, txt
  };
},
{
  persist: {
    omit: ['isMobile', 'isMenu', 'langs', 'txt', 'userLang']
  }
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot));
}